import { createFileRoute } from '@tanstack/react-router';
import { SupervisionPage } from '@web/modules/conversations/supervision/supervision-page';

interface SupervisionSearch {
  /** The queue whose board is open (the first one by default). */
  queue?: string;
}

export const Route = createFileRoute('/_app/supervision')({
  validateSearch: (search: Record<string, unknown>): SupervisionSearch =>
    typeof search['queue'] === 'string' && search['queue'] !== '' ? { queue: search['queue'] } : {},
  component: SupervisionRoute,
});

function SupervisionRoute() {
  const { queue } = Route.useSearch();
  return <SupervisionPage queueId={queue} />;
}
